/**
 * Converts a string into a `Uint8Array`.
 */

const stringToUint8Array = (input: string): Uint8Array =>
    new Uint8Array(input.split('').map(c => c.charCodeAt(0)));

export default stringToUint8Array;